/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { UserProfile } from '../User/User.defs';
import { AvatarSize } from './Avatar.types';

/**
 * The props for `<Avatar />`.
 */
export interface AvatarProps extends SdsDivProps {
  /**
   * Avatar size.
   */
  avatarSize: AvatarSize;

  /**
   * Is the avatar interactive?
   */
  isInteractive?: boolean;

  /**
   * Show a tooltip displaying the user's name.
   */
  showTooltip?: boolean;

  /**
   * DXP user profile.
   */
  user: UserProfile;
}

/**
 * The default prop values for `<Avatar />`.
 */
export const avatarDefaults = {
  isInteractive: false,
  showTooltip: false,
};
